/**
 * CommonMetricsLibrary is a metrics reporting frameworks shared between all SMB templates
 * The purpose of this library is to have metrics reporting to be agnostics from the underlining frontend metrics reporting library we are using.
 * Currently, turnstile is the frontend metrics reporting library we use in SMB templates. It's possible we will switch to Datadog in the future.
 * Having the reporting logics in the shared library would simplify the migration.
 */
class CommonMetricsLibrary {
    constructor(){
        this.REQUIRED_TURNSTILE_TAGS = ['data-tn-element', 'data-tn-action'];
        this.REQUIRED_DATADOG_TAGS = ['actionName', 'customActionType', 'element'];
    }

    report(tags) {
        if (window.turnstile) {
            this._turnstile_report(tags);
        }
    }

    /**
     * turnstile metrics reporting takes 2 parameters. For example, turnstile.turn(element, tags)
     * where element is normally the html node user interacted with and tags is a map of key value pairs
     * Since we are calling turnstile programmatically, the element parameter doesn't really matter
     *
     * @param turnstileTags
     * @private
     */
    _turnstile_report(turnstileTags) {
        if(this._validate_turnstile_tags(turnstileTags)) {
            turnstile.turn(document.body, turnstileTags);
        }
    }

    _validate_turnstile_tags(turnstileTags) {
        if (typeof turnstileTags !== 'object' || turnstileTags === null) {
            console.error('turnstile tags do not exist');
            return false;
        }
        for (const requiredTurnstileTag of this.REQUIRED_TURNSTILE_TAGS) {
            if(!turnstileTags.hasOwnProperty(requiredTurnstileTag)) {
                console.error(`Required turnstile tag ${requiredTurnstileTag} does not exist.`);
                return false;
            }
        }
        return true;
    }

    /**
     * Datadog metrics reporting takes 2 parameters. For example, DD_RUM.addAction(actionName, tags)
     * where action name is a string and tags is a map of key value pairs
     * @param datadogTags
     * @private
     */
    _datadog_report(datadogTags) {
        // TODO: implement later when we switch to datadog
    }

    _validate_datadog_tags(datadogTags) {
        // TODO: implement later when we switch to datadog
    }

    _convert_turnstile_tags_to_datadog_tags(tags) {
        // TODO: implement later when we switch to datadog
    }

}
window.addEventListener("load", () => {
    window.commonMetricsLibrary = new CommonMetricsLibrary();
}, {once: true});